<div fxLayout="column" fxFlex="100" fxLayoutAlign="left">
  <div [ngClass]="getColoreHeader()" class="container">
    {{valore.dd}}
  </div>
<!--  <div [ngClass]="getColore(pa)" class="container" *ngFor="let pa of valore.attivitas"> -->
    <div [ngClass]="getColore(pa)" class="container" *ngFor="let pa of attivitas">
  </div>
</div>
